// Czyste funkcje pomocnicze (geo, pasma) -- wydzielone z App.js, zeby dalo
// sie je testowac jednostkowo bez montowania calego monolitycznego App.
// App.js importuje je z powrotem, wiec zachowanie sie nie zmienia.

export function latLonToGrid(lat, lon, precision = 6) {
  lon += 180; lat += 90;
  const FIELD = 'ABCDEFGHIJKLMNOPQR';   // 18 liter, pola: 20°lon x 10°lat
  const SUB = 'ABCDEFGHIJKLMNOPQRSTUVWX'; // 24 litery, podkwadraty: 5'lon x 2.5'lat
  let field_lon = Math.floor(lon / 20);
  let field_lat = Math.floor(lat / 10);
  let grid = FIELD[field_lon] + FIELD[field_lat];

  let rem_lon = lon - field_lon * 20;
  let rem_lat = lat - field_lat * 10;
  let sq_lon = Math.floor(rem_lon / 2);
  let sq_lat = Math.floor(rem_lat / 1);
  grid += sq_lon.toString() + sq_lat.toString();

  if (precision >= 6) {
    rem_lon -= sq_lon * 2;
    rem_lat -= sq_lat * 1;
    let sub_lon = Math.min(23, Math.max(0, Math.floor(rem_lon / (2/24))));
    let sub_lat = Math.min(23, Math.max(0, Math.floor(rem_lat / (1/24))));
    grid += SUB[sub_lon].toLowerCase() + SUB[sub_lat].toLowerCase();
  }
  return grid;
}

export function gridToLatLon(grid) {
  if (!grid || grid.length < 4) return null;
  grid = grid.toUpperCase();
  const FIELD = 'ABCDEFGHIJKLMNOPQR';
  const field_lon = FIELD.indexOf(grid[0]);
  const field_lat = FIELD.indexOf(grid[1]);
  if (field_lon < 0 || field_lat < 0) return null;
  const sq_lon = parseInt(grid[2], 10);
  const sq_lat = parseInt(grid[3], 10);
  if (isNaN(sq_lon) || isNaN(sq_lat)) return null;

  let lon = field_lon * 20 + sq_lon * 2;
  let lat = field_lat * 10 + sq_lat * 1;
  let lon_size = 2, lat_size = 1;

  if (grid.length >= 6) {
    const SUB = 'ABCDEFGHIJKLMNOPQRSTUVWX';
    const sub_lon = SUB.indexOf(grid[4]);
    const sub_lat = SUB.indexOf(grid[5]);
    if (sub_lon >= 0 && sub_lat >= 0) {
      lon += sub_lon * (2/24);
      lat += sub_lat * (1/24);
      lon_size = 2/24; lat_size = 1/24;
    }
  }

  // Srodek komorki
  lon += lon_size/2; lat += lat_size/2;
  return { lat: lat - 90, lon: lon - 180 };
}

export function haversineKm(lat1, lon1, lat2, lon2) {
  const R = 6371.0088;
  const toRad = d => d * Math.PI / 180;
  const dphi = toRad(lat2 - lat1);
  const dlambda = toRad(lon2 - lon1);
  const a = Math.sin(dphi/2)**2 + Math.cos(toRad(lat1))*Math.cos(toRad(lat2))*Math.sin(dlambda/2)**2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

// Namiar (initial bearing / forward azimuth) od punktu 1 do punktu 2, w
// stopniach 0-360 (0=N, 90=E, 180=S, 270=W) -- standardowa formula
// nawigacyjna (great-circle bearing), nie linia prosta na plaskiej mapie.
export function bearingDeg(lat1, lon1, lat2, lon2) {
  const toRad = d => d * Math.PI / 180;
  const phi1 = toRad(lat1), phi2 = toRad(lat2), dlambda = toRad(lon2 - lon1);
  const y = Math.sin(dlambda) * Math.cos(phi2);
  const x = Math.cos(phi1)*Math.sin(phi2) - Math.sin(phi1)*Math.cos(phi2)*Math.cos(dlambda);
  return (Math.atan2(y, x) * 180 / Math.PI + 360) % 360;
}

// Namiar -> 16-kierunkowa roza wiatrow (N, NNE, NE, ...) -- czytelniejsze
// na pierwszy rzut oka niz sama liczba stopni, ale liczba zostaje widoczna
// rowniez (uzywane razem, nie zamiennie).
export function bearingToCompass(deg) {
  const directions = ['N','NNE','NE','ENE','E','ESE','SE','SSE','S','SSW','SW','WSW','W','WNW','NW','NNW'];
  return directions[Math.round(deg / 22.5) % 16];
}

// Lustrzane odbicie backendowego freq_to_band (Python) -- potrzebne do
// sprawdzenia "nowe pasmo dla tego kraju" PODCZAS wpisywania (przed
// zapisaniem QSO, gdy band jest jeszcze tylko czastka frequency, nie
// osobnym polem formularza).
export function freqToBandJs(f) {
  const bands = [[1.8,2.0,'160m'],[3.5,4.0,'80m'],[5.3,5.4,'60m'],[7.0,7.3,'40m'],
    [10.1,10.15,'30m'],[14.0,14.35,'20m'],[18.068,18.168,'17m'],[21.0,21.45,'15m'],
    [24.89,24.99,'12m'],[28.0,29.7,'10m'],[50.0,54.0,'6m'],[144.0,148.0,'2m'],
    [420.0,450.0,'70cm'],[1240.0,1300.0,'23cm']];
  for (const [lo,hi,b] of bands) if (f>=lo && f<=hi) return b;
  return 'other';
}

// ── Walidacja lokatora Maidenhead ────────────────────────────────────────────
// Format: 2 litery (A-R) + 2 cyfry + opcjonalnie 2 litery (a-x) + opcjonalnie
// 2 cyfry. Np. "KO02", "JO91ab", "KO02le34". Zwraca true dla poprawnego lub
// pustego (puste = brak, nie blad -- pole opcjonalne).
export function isValidGrid(grid) {
  if (!grid) return true; // puste pole nie jest bledem
  return /^[A-R]{2}[0-9]{2}([A-X]{2}([0-9]{2})?)?$/i.test(grid.trim());
}

// ── Czy czestotliwosc miesci sie w pasmie amatorskim ─────────────────────────
// Wykorzystuje freqToBandJs: jesli zwroci 'other' lub '' -> poza pasmami.
// Puste = brak, nie blad.
export function isFreqInHamBand(freqStr) {
  if (!freqStr) return true;
  const f = parseFloat(freqStr);
  if (isNaN(f)) return false;
  const band = freqToBandJs(f);
  return band !== 'other' && band !== '';
}

// Porownanie wersji aplikacji liczbowo, segment po segmencie ("1.57.10" > "1.57.2").
// Uzywane przez baner "dostepna nowa wersja" -- pokazujemy go tylko, gdy serwer
// ma NOWSZA wersje niz wczytany kod.
export function isNewerVersion(a, b) {
  const pa = String(a).split('.').map(n => parseInt(n, 10) || 0);
  const pb = String(b).split('.').map(n => parseInt(n, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    if ((pa[i] || 0) !== (pb[i] || 0)) return (pa[i] || 0) > (pb[i] || 0);
  }
  return false;
}
